import { useState as h } from "react";
const s = () => {
  const [e, t] = h("ThemeLightGreen");
  return [e, (m) => {
    t(m);
  }];
};
export {
  s as useTheme
};
